import { FC, InputHTMLAttributes } from 'react'

import { Chip } from '@joor/design-system'
import { useField } from 'formik'
import compact from 'lodash/compact'
import filter from 'lodash/filter'

import { BaseProps } from '../Field'
import {
  Asterisk,
  Caption,
  LabelText,
  StyledInputContainer,
} from '../NumberInput/styles'
import { StyledMultiValueInput } from './styles'

export type PropsType = BaseProps & InputHTMLAttributes<HTMLInputElement>

const MultiValueInput: FC<PropsType> = ({ required, label, ...props }) => {
  const [
    {
      onChange: _fieldOnChange,
      onBlur: _fieldOnBlur,
      value: _fieldValue,
      ...field
    },
    meta,
    { setValue, setTouched },
  ] = useField({
    disabled: props.disabled,
    name: props.name,
  })
  const shouldShowError = meta.touched && !!meta.error
  const error =
    typeof meta.error === 'string'
      ? meta.error
      : compact(meta.error as unknown as Array<{ label: string }>)[0]?.label
  return (
    <label htmlFor={props.name}>
      <LabelText disabled={props.disabled} hasError={!!shouldShowError}>
        {label} {required ? <Asterisk>*</Asterisk> : null}
      </LabelText>
      <StyledInputContainer
        disabled={props.disabled}
        hasError={shouldShowError}
      >
        <StyledMultiValueInput
          onAddChip={(addedChip) => {
            const newChip = {
              value: `${addedChip.value}_${Date.now()}`,
              label: addedChip.label,
            }
            setValue([...meta.value, newChip])
          }}
          onCloseChip={(removedChip) => {
            setValue(
              filter(
                meta.value,
                (chip: Chip) => chip.value !== removedChip.value,
              ),
            )
          }}
          onBlur={() => setTouched(true)}
          value={meta.value ?? []}
          {...field}
          {...props}
        />
      </StyledInputContainer>
      {(props.caption || !!shouldShowError) && (
        <Caption disabled={props.disabled} hasError={!!shouldShowError}>
          {error || props.caption}
        </Caption>
      )}
    </label>
  )
}

export default MultiValueInput
